<h3 mat-dialog-title class="montserrat-medium mb-4 text-gray-500">Reject Reasons</h3>
<div mat-dialog-content>
    <p>Please specify why the campaign is being rejected</p>
    <mat-form-field class="txtarea">
        <mat-label>Reasons</mat-label>
        <textarea matInput placeholder="Ex. This campaign was rejected because..." [(ngModel)]="data.rejectReason"
            required></textarea>
    </mat-form-field>
</div>
<div class="d-flex align-items-center justify-content-center">
    <button class="btn btn-md btn-gray-500" [mat-dialog-close]="data.rejectReason"
        [disabled]="!data.rejectReason?.trim()" cdkFocusInitial>
        save
    </button>
    <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>cancel</button>
</div>